var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCartAdded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 8C2.67157 8 2 7.32843 2 6.5V4.5C2 3.67157 2.67157 3 3.5 3H20.5C21.3284 3 22 3.67157 22 4.5V6.5C22 7.32843 21.3284 8 20.5 8V18C20.5 19.6569 19.1569 21 17.5 21H6.5C4.84315 21 3.5 19.6569 3.5 18L3.5 8ZM3.5 4.5H20.5V6.5H3.5L3.5 4.5ZM19 8H5V18C5 18.8284 5.67157 19.5 6.5 19.5H17.5C18.3284 19.5 19 18.8284 19 18V8Z",
    fill: "#505768"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2072 10.7072L11.7072 16.2072C11.3167 16.5977 10.6835 16.5977 10.293 16.2072L6.79297 12.7072L8.20718 11.293L11.0001 14.0859L15.793 9.29297L17.2072 10.7072Z",
    fill: "#34A597"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCartAdded);
export default __webpack_public_path__ + "static/media/icon_cart_added.1e531753f0e9e024aa03ac2f85e9b383.svg";
export { ForwardRef as ReactComponent };